var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import IconButton from '@material-ui/core/IconButton';
import { useTheme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SvgIcon from '@material-ui/core/SvgIcon';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Help from '@material-ui/icons/Help';
import Home from '@material-ui/icons/Home';
import MoreVert from '@material-ui/icons/MoreVert';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    homeLogo: {
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            width: 40,
            height: 40
        },
        height: 50,
        width: 50
    },
    sideIcon: {
        height: 35,
        width: 35
    }
}));
export const LogoIcon = (props) => {
    const classes = useStyles(useTheme());
    // tslint:disable:max-line-length
    return (React.createElement(SvgIcon, Object.assign({ className: classes.homeLogo, color: 'inherit', viewBox: '0 0 90 90' }, props),
        React.createElement("path", { d: 'M62.31,55.12a23.5,23.5,0,1,1,0-25.24l16-10.2a42.5,42.5,0,1,0,0,45.64Z' }),
        React.createElement("path", { d: 'M81,42.5a38.25,38.25,0,0,1-3.63,16.28l.55.35L80.77,61a42.35,42.35,0,0,0,0-36.9l-3.41,2.17A38.11,38.11,0,0,1,81,42.5Z' }),
        React.createElement("polygon", { points: '80.77 60.95 80.77 60.95 77.92 59.13 80.77 60.95' }),
        React.createElement("path", { d: 'M64.55,34.39a23.42,23.42,0,0,1-2.24,20.73l3.37,2.15A27.35,27.35,0,0,0,68,32.2Z' }),
        React.createElement("path", { d: 'M71.88,52.32l3.47,2.21A34.8,34.8,0,0,0,72,23.71l-3.37,2.14a30.78,30.78,0,0,1,3.25,26.47Z' })));
    // tslint:enable:max-line-length
};
export const HelpIcon = (props) => {
    const classes = useStyles(useTheme());
    return (React.createElement(IconButton, Object.assign({ color: 'inherit' }, props),
        React.createElement(Help, { classes: { root: classes.sideIcon } })));
};
export const HomeIcon = (props) => {
    const classes = useStyles(useTheme());
    return (React.createElement(IconButton, Object.assign({ color: 'inherit' }, props),
        React.createElement(Home, { classes: { root: classes.sideIcon } })));
};
export const LogoutIcon = (props) => {
    const classes = useStyles(useTheme());
    return (React.createElement(IconButton, Object.assign({ edge: 'end', color: 'inherit' }, props),
        React.createElement(ExitToApp, { classes: { root: classes.sideIcon } })));
};
export const ProfileIcon = (props) => {
    const classes = useStyles(useTheme());
    return (React.createElement(IconButton, Object.assign({ "aria-label": 'Account of current user', "aria-haspopup": 'true', color: 'inherit' }, props),
        React.createElement(AccountCircle, { classes: { root: classes.sideIcon } })));
};
export const ShowMoreIcon = (props) => {
    const { mobileMenuId, onMobileMenuOpen } = props, iconButtonProps = __rest(props, ["mobileMenuId", "onMobileMenuOpen"]);
    return (React.createElement(IconButton, Object.assign({ "aria-label": 'Show more', "aria-controls": mobileMenuId, "aria-haspopup": 'true', onClick: onMobileMenuOpen, color: 'inherit' }, iconButtonProps),
        React.createElement(MoreVert, null)));
};
//# sourceMappingURL=Icons.js.map